import React from "react";
import { Loader2, CheckCircle2, XCircle, Circle } from "lucide-react";
import { Button } from "@/components/ui/button";

const STEP_ICON = {
    pending: <Circle className="h-3.5 w-3.5 text-slate-600" />,
    running: <Loader2 className="h-3.5 w-3.5 animate-spin text-indigo-300" />,
    done: <CheckCircle2 className="h-3.5 w-3.5 text-emerald-300" />,
    failed: <XCircle className="h-3.5 w-3.5 text-rose-300" />,
};

export default function AnalysisProgress({ analysis, onOpen, onHome, openLabel = "Open analysis page" }) {
    const steps = analysis?.steps || [];
    const failed = analysis?.status === "failed";
    return (
        <div data-testid="analysis-progress" className="surface rounded-2xl p-6">
            <div className="flex items-center gap-3 text-sm text-slate-200">
                {failed ? <XCircle className="h-4 w-4 text-rose-300" /> : analysis?.status === "done" ? <CheckCircle2 className="h-4 w-4 text-emerald-300" /> : <Loader2 className="h-4 w-4 animate-spin text-indigo-300" />}
                {failed ? `Analysis failed: ${analysis?.error || "unknown error"}` : analysis?.status === "done" ? "Done — opening your analysis…" : "Analysing each approved profile, then running the AI analysis. About a minute."}
            </div>
            <ul className="mt-5 space-y-2.5">
                {(steps.length ? steps : [{ key: "x", label: "Starting…", status: "running" }]).map((s) => (
                    <li key={s.key} className="flex items-center gap-3 text-sm" data-testid={`analysis-step-${s.key}`}>
                        {STEP_ICON[s.status] || STEP_ICON.pending}
                        <span className={s.status === "pending" ? "text-slate-500" : "text-slate-200"}>{s.label}</span>
                    </li>
                ))}
            </ul>
            {failed && (
                <div className="mt-5 flex gap-2">
                    <Button onClick={onOpen} className="bg-indigo-500 hover:bg-indigo-400 text-white">{openLabel}</Button>
                    <Button variant="outline" onClick={onHome} className="border-white/10 bg-white/[0.03] text-slate-200">Go to dashboard</Button>
                </div>
            )}
        </div>
    );
}
